document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".product-wishlist-btn");
    if (!btn) return;

    const product = {
      productId: btn.dataset.productId,
      variantId: btn.dataset.variantId,
      title: btn.dataset.productTitle,
      url: btn.dataset.productUrl,
      image: btn.dataset.productImage
    };

    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    const exists = wishlist.some(
      item => item.variantId === product.variantId
    );

    if (!exists) {
      wishlist.push(product);
      localStorage.setItem("wishlist", JSON.stringify(wishlist));
    }

    // ✅ UI feedback instead of alert
    btn.classList.add("is-active");
    btn.querySelector(".wishlist-icon").textContent = "❤️";
    btn.querySelector("span:last-child").textContent = "Added to Wishlist";
  });
});
